import React from 'react';
import Game from './Game';

const DailyChallenge = ({ points, setPoints, streak, setStreak }) => {
  return (
    <div>
      <p className="text-center text-sm text-gray-600 dark:text-gray-400 mb-2">
        Today's puzzle — same for everyone. Leaderboard rankings coming soon.
      </p>
      <Game
        points={points}
        setPoints={setPoints}
        streak={streak}
        setStreak={setStreak}
        mode="daily"
      />
    </div>
  );
};

export default DailyChallenge;
